import React, { createContext, useContext, useEffect, useState } from 'react'
import { get, store } from '../utils/Storage'

export const AuthContext = createContext({})

export const AuthProvider = props => {
  const userStorage = get('user')
  const enterpriseStorage = get('enterprise')
  const [user, setUser] = useState({
    id: userStorage?._id,
    name: userStorage?.name,
    username: userStorage?.username,
    email: userStorage?.email,
    profile: userStorage?.profile,
    disabled: userStorage?.disabled,
    enterprise: {
      id: enterpriseStorage?._id,
      name: enterpriseStorage?.name
    }
  })

  useEffect(() => {
    if(userStorage){
      userStorage.name = user.name
      userStorage.email = user.email
      userStorage.username = user.username
      userStorage.disabled = user.disabled
      store('user', userStorage)
    }
  }, [user])// eslint-disable-line react-hooks/exhaustive-deps

  return (
    <AuthContext.Provider value={{user, setUser}} >
      {props.children}
    </AuthContext.Provider>
  )
}

export const useAuth = () => useContext(AuthContext)
